module.exports = __webpack_public_path__ + "img/Rate.dbee0df8.webp";